import { ApolloClient, ApolloLink, HttpLink, InMemoryCache } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { Observable, getMainDefinition } from '@apollo/client/utilities';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { CachePersistor, LocalStorageWrapper } from 'apollo3-cache-persist';
import { auth } from '../../services/firebase';
export enum GraphQLHeaders {
    HASURA_ROLE = 'x-hasura-role',
    HASURA_ORGANIZATION_ID = 'x-hasura-org-id',
}

export const createApolloClient = (
    url: string = import.meta.env.VITE_HASURA_GRAPHQL_API_ENDPOINT,
    wsUrl: string = import.meta.env.VITE_HASURA_GRAPHQL_WS_ENDPOINT
) => {
    const getHeaders = async () => {
        const currentUser = auth.currentUser;
        const token = currentUser ? await currentUser.getIdToken() : null;
        // console.log('token', token);
        // // 0: extensions:
        // //    code: "postgres-error"
        // //    path: "$"
        // //    message: "connection error"
        // // Object
        // // message: "connection error"
        // return {
        //     authorization: `Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjNmOWEwNTBkYzRhZTgyOGMyODcxYzMyNTYzYzk5ZDUwMjc3ODRiZTUiLCJ0eXAiOiJKV1QifQ.eyJhdXRoVXNlcklkIjoiMDNHc0lvdWZpaWR1MndmWlFoaEU3UDhCeUR1MSIsIm9yZ2FuaXphdGlvbklkIjoiNjgxMzE4YTM5MGU5OWZlYjhkMWNkZWJkIiwidXNlcklkIjoiNjgxMzE4YTQ5MGU5OWZlYjhkMWNkZWJlIiwic2VhdElkIjoiZGVmYXVsdC1mcmVlLXNlYXQtaWQiLCJwbGFuIjoiZnJlZSIsInRvdGFsU2VhdHMiOjAsInRvdGFsQWN0aXZlU2VhdHMiOjAsInN1YnNjcmlwdGlvblN0YXR1cyI6ImFjdGl2ZSIsInJvbGVzIjpbIk9SR0FOSVpBVElPTl9NRU1CRVIiLCJPUkdBTklaQVRJT05fQURNSU4iXSwiY2xhaW1zVXBkYXRlZEF0IjoxNzQ2MDgxOTcwODA0LCJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vemFwbGlmeS1zdGFnaW5nIiwiYXVkIjoiemFwbGlmeS1zdGFnaW5nIiwiYXV0aF90aW1lIjoxNzQ2MDgxODc5LCJ1c2VyX2lkIjoiMDNHc0lvdWZpaWR1MndmWlFoaEU3UDhCeUR1MSIsInN1YiI6IjAzR3NJb3VmaWlkdTJ3ZlpRaGhFN1A4QnlEdTEiLCJpYXQiOjE3NDYxMDM2NDEsImV4cCI6MTc0NjEwNzI0MSwiZW1haWwiOiJ1c2VyLTE3NDYwODE4NzExOTBAdGVzdGVtYWlsLTE3NDYwODE4NzExOTAuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsImZpcmViYXNlIjp7ImlkZW50aXRpZXMiOnsiZW1haWwiOlsidXNlci0xNzQ2MDgxODcxMTkwQHRlc3RlbWFpbC0xNzQ2MDgxODcxMTkwLmNvbSJdfSwic2lnbl9pbl9wcm92aWRlciI6InBhc3N3b3JkIn19.cudbYgsZ_F7zZOMZgTZJzKdDWC8f-QKQvfDvYFZdJuBREgAsATqxTeh0VxOt48RECSP1H46XcC1gzDJnpUqEOXh4I4qk7bbtI7yJB5F2i6-ITevyW5PmlBy1uKuyZJ1pyU9SaZ4l3V_6f3yLSwll-n6saqq9HI168By9Quhi2XL_7d9igS2ecrjg6qdOnKV6tj1hedyd8ESTwuJA80Jdmh-U_0KH5uyo0H5NF-5zhTMgcTOh5Y4JXRDOZgTJp73Z8LPaSjsGS0W8jy5M5SZYdh6SwgfVn30EJlOxYrXcY-j6lB9RQT6nuufw8WjWvtG9wdOq9uW7U7Mmn7wscsibOQ`,
        // };
        return {
            authorization: `Bearer ${token}`,
        };
    };
    const wsLink = new GraphQLWsLink(
        createClient({
            url: wsUrl,
            connectionParams: async () => {
                try {
                    console.log('running connectionParams');
                    const headers = await getHeaders();
                    return { headers };
                } catch (error) {
                    console.error('[GraphQL WebSocket] Connection error:', error);
                    throw error;
                }
            },
            on: {
                error: (error) => {
                    console.error('[GraphQL WebSocket on Error Handler] Error:', error);
                },
            },
            retryAttempts: 5,
            retryWait: async (retryCount) => {
                console.warn('[GraphQL WebSocket] Reconnecting...', retryCount);
                return new Promise((resolve) => setTimeout(resolve, Math.min(1000 * 2 ** retryCount, 30000)));
            },
        })
    );

    const authLink = new ApolloLink((operation, forward) => {
        return new Observable((observer) => {
            const ensureToken = async () => {
                const authHeaders = await getHeaders();
                if (authHeaders.authorization?.length < 10) {
                    console.error('No authorization header could be generated');
                    return;
                }

                operation.setContext(({ headers = {} }) => ({
                    headers: {
                        ...headers,
                        ...authHeaders,
                    },
                }));

                forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                });
            };
            ensureToken();
        });
    });

    const errorLink = onError(({ graphQLErrors, networkError, operation }) => {
        if (graphQLErrors) {
            console.error(`[GraphQL auth client error]:`, operation.operationName, operation.variables, graphQLErrors);
            // get a new token
        }
        if (networkError) {
            console.error(`[GraphQL Network error]: ${networkError}`);
        }
    });

    const httpLink = new HttpLink({
        uri: url,
    });

    const splitLink = ApolloLink.split(
        ({ query }) => {
            const definition = getMainDefinition(query);
            return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
        },
        wsLink,
        httpLink
    );

    const link = ApolloLink.from([errorLink, authLink, splitLink]);

    const cache = new InMemoryCache();
    // const persistor = new CachePersistor({
    //     cache,
    //     storage: new LocalStorageWrapper(window.localStorage),
    //     debug: import.meta.env.DEV,
    //     trigger: 'write',
    //     maxSize: 12582912,
    //     debounce: 1000,
    // });
    // console.log('restoring cache');
    // // await persistor.restore().catch((error) => {
    // //     console.error('Error restoring cache', error);
    // // });
    // console.log('cache restored');

    const client = new ApolloClient({
        link: link,
        cache,
    });

    return {
        client,
        // persistor,
        clearCache: async () => {
            console.log('clearing cache');
            // await persistor.purge();
            await client.clearStore();
        },
        resetCache: async () => {
            try {
                await client.resetStore();
            } catch (e) {
                console.error('Error resetting the cache:', e);
            }
        },
    };
};
